module.exports = __webpack_public_path__ + "media/images/icons/toca-en-vivo-734946f1e90ca1d6ad85105be112f8ce.svg";